// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"ErrorPage_errorPage__23Fm6","button":"ErrorPage_button__1qPbm"};